import React from 'react'
import ContactForm from '../components/ContactForm'

export default function ContactPage() {
  return (
    <div className="bg-white pt-10 sm:pt-16 pb-0">
      <section className="max-w-7xl mx-auto px-4 sm:px-6">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Venstre kolonne: Kontaktinfo, telefontider og børnepriser uden indre boks */}
          <div className="lg:col-span-5 space-y-6">
            <div className="space-y-6">
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-[#241F1C]">Direkte kontakt</h3>
                <p className="text-xs text-[#6E635C] mt-1">Vi står altid klar til en snak om din fest.</p>
              </div>
            </div>

            {/* Børnepriser */}
            <div className="border-t border-[#E6DFD5] pt-6 space-y-2">
              <div className="flex items-center gap-2 text-[#C25E27] font-bold text-sm">
                <i className="fa-solid fa-child text-base" aria-hidden="true" />
                <span>Børnepriser</span>
              </div>
              <ul className="text-xs sm:text-sm text-[#241F1C] space-y-1.5">
                <li>• Børn fra 5 til og med 12 år: <strong>½ pris</strong></li>
                <li>• Børn fra 0 til og med 4 år: <strong>Gratis</strong></li>
              </ul>
            </div>

            {/* Sociale medier / Instagram */}
            <div className="border-t border-[#E6DFD5] pt-6 space-y-2">
              <div className="flex items-center gap-2 text-[#241F1C] font-bold text-sm">
                <i className="fa-brands fa-instagram text-[#C25E27] text-base" aria-hidden="true" />
                <span>Følg os på Instagram</span>
              </div>
              <p className="text-xs sm:text-sm text-[#6E635C]">
                Se de seneste billeder af vores helstegte pattegrise, arrangementer og udlejningsudstyr.
              </p>
              <a
                href="https://www.instagram.com/overgaard_pattegris?vrfl=MXB0NmY0Z3pkeDZ1bA%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-[#C25E27] hover:text-[#A84E1C] transition-colors pt-1"
              >
                <span>@overgaard_pattegris</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>

            {/* Telefontider */}
            <div className="border-t border-[#E6DFD5] pt-6 space-y-2">
              <div className="flex items-center gap-2 text-[#241F1C] font-bold text-sm">
                <i className="fa-solid fa-clock text-[#C25E27]" aria-hidden="true" />
                <span>Telefontider</span>
              </div>
              <div className="text-xs sm:text-sm text-[#6E635C] divide-y divide-[#E6DFD5]">
                <div className="flex justify-between py-2 border-b border-[#E6DFD5]">
                  <span>Hverdage:</span>
                  <span className="font-medium text-[#241F1C]">Kl. 15.00 – 19.00</span>
                </div>
                <div className="flex justify-between py-2 border-b border-[#E6DFD5]">
                  <span>Weekend &amp; helligdage:</span>
                  <span className="font-medium text-[#241F1C]">Kl. 09.00 – 19.00</span>
                </div>
              </div>
            </div>
          </div>

          {/* Højre kolonne: Kontaktformular */}
          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>

      {/* GOOGLE MAPS I SORT/HVID */}
      <section className="mt-10 sm:mt-14 relative w-full h-56 sm:h-64 bg-[#241F1C] overflow-hidden" aria-label="Find Overgaard Pattegrise">
        <iframe
          title="Kort over Overgaard Pattegrise – Simmelbrovej 52, 7260 Sønder Omme"
          src="https://maps.google.com/maps?q=Simmelbrovej%2052,%207260%20S%C3%B8nder%20Omme&t=&z=14&ie=UTF8&iwloc=&output=embed"
          className="w-full h-full border-0 filter grayscale contrast-125 brightness-95"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        {/* Adressebadge på maps */}
        <div className="absolute top-4 left-4 sm:top-5 sm:left-6 z-10 bg-white/95 backdrop-blur-sm p-3.5 sm:p-4 shadow-xl border border-[#E6DFD5] max-w-xs">
          <div className="flex items-start gap-2.5">
            <i className="fa-solid fa-location-dot text-[#C25E27] text-base mt-0.5" aria-hidden="true" />
            <div>
              <p className="font-bold text-xs sm:text-sm text-[#241F1C]">Overgaard Pattegrise</p>
              <p className="text-[11px] sm:text-xs text-[#6E635C] mt-0.5">Simmelbrovej 52, 7260 Sønder Omme</p>
              <a
                href="https://maps.google.com/?q=Simmelbrovej+52,+7260+Sønder+Omme"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#C25E27] hover:text-[#A84E1C] mt-1.5"
              >
                <span>Find vej</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[9px]" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
